import React, { useState } from 'react'
import UploadContentContext from './uploadContentContext';
const UploadContentState = (props) => {
    const [videoBlobToFile, setVideoBlobToFile] = useState({});
    const [attachments, setAttachments] = useState([]);
    const [deletedAttachmentsId, setDeletedAttachmentsId] = useState([]);
    const handleReset = () => {
        setVideoBlobToFile({});
        setAttachments([]);
        setDeletedAttachmentsId([]);
    }

    return (
        <UploadContentContext.Provider
            value={{
                attachments,
                setAttachments,
                videoBlobToFile,
                setVideoBlobToFile,
                handleReset,
                deletedAttachmentsId,
                setDeletedAttachmentsId
            }}>
            {props.children}
        </UploadContentContext.Provider>
    )
}

export default UploadContentState
